import { render, staticRenderFns } from "./question-answer.vue?vue&type=template&id=323e0ea0"
import script from "./question-answer.vue?vue&type=script&lang=js"
export * from "./question-answer.vue?vue&type=script&lang=js"
import style0 from "./question-answer.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports